<template>
	<div>
		<div class="device-mobile" v-if="isMobile">
			<div class="vocational">
				<div class="top" style="width: 100vw;height:53.333333vw;">
					<el-carousel trigger="click" height='53.333333vw'>
						<el-carousel-item v-for="(item, index) in topList" :key="index">
							<img :src="webImg + item +imgCut(1000,530,'r')" alt="" srcset="" style="width: 100vw;!important; height:53.333333vw;"
								@dragstart.prevent>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="card">
					<div class="card-content">
						<div class="navigation">
							<div class="navigationItem">
								<img src="../assets/home.png" alt="" @dragstart.prevent>
								<span @click="toTopImg()">{{ $t('nav.home') }}</span>
								<span class="arrow">></span>
								<span>{{ sectionTitle }}</span>
								<span class="arrow">></span>
								<span>{{ info.title }}</span>
							</div>
						</div>
						<div class="tabbar">
							<div class="item active">
								<div class="txt">{{ info.title }}</div>
								<div class="line"></div>
							</div>
						</div>
						<div class="net" v-if="info.link && checkURL(info.link)"><a :href="info.link">{{ info.link }}</a>
						</div>
						<div class="net" v-if="info.link && !checkURL(info.link)"><a :href="'http://' + info.link">{{
							info.link }}</a>
						</div>
						<div class="introduce" v-if="info.content" v-html="formatRichText(info.content)"></div>
						<div class="jx" v-for="(item, index) in info.label" v-if="info.label && info.label.length > 0">
							<div style="display: flex;">
								<div class="img-box">
									<img src="../assets/jx.png" alt="" @dragstart.prevent>
								</div>
								<div class="txt">{{ item.label }}</div>
							</div>
							<div v-for="(item1, index) in item.children">
								<div class="txt"> {{ item1.label }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-content">
						<div class="tabbar" v-if="info.moduleOne">
							<div class="item active">
								<div class="txt">{{ info.moduleOne }}</div>
								<div class="line"></div>
							</div>
						</div>

						<div class="nav" v-if="list && list.length > 0">
							<div style="position: relative;">
								<div class="navMain">
									<div @click="navMainClick(index)" v-for="(item, index) in list" class="navMainItem"
										:class="{ navMainItem1: count == index }">
										<div v-html="item.name"></div>
									</div>
								</div>
							</div>
						</div>
						
						<div class="navImg" v-if="listOne && listOne.length > 0">
							<div class="navImgItem" v-for="(item, index) in listOne">
								<img :src="webImg + item.picture + imgCut(345,338)" alt="" @dragstart.prevent>
								
								<div class="navMainTitle txt-ellipsis-1">{{ item.title }}</div>
							</div>
						</div>
					</div>
				</div>

				<div class="card">
					<div class="card-content">
						<div class="tabbar" v-if="info.moduleTwo">
							<div class="item active">
								<div class="txt">{{ info.moduleTwo }}</div>
								<div class="line"></div>
							</div>
						</div>
						<div class="technology" v-if="listTwo && listTwo.length > 0">
							<div class="technologyName">
								<div style="padding: 0.266667rem">
									<div class="angin" v-if="listTwo[num - 1]">{{ listTwo[num - 1].title }}</div>
									<div class="anginText" v-if="listTwo[num - 1]" v-html="listTwo[num - 1].content">
									</div>
								</div>
								<div class="anginImg">
									<div>{{ num }}/<span>{{ totalNum }}</span> </div>
									<div class="aLeft" @click="aLeftClick()"> <i class="el-icon-arrow-left"></i></div>
									<div class="aRight" @click="aRight()"> <i class="el-icon-arrow-right"></i></div>
								</div>
							</div>

							<img class="technologyImg" v-if="listTwo[num - 1]" :src="webImg + listTwo[num - 1].picture + imgCut(710,400)"
								alt="" @dragstart.prevent>
						</div>
					</div>
				</div>

			

				<div class="card">
					<div class="card-content">
						<div class="tabbar" v-if="info.moduleThree">
							<div class="item active">
								<div class="txt">{{ info.moduleThree }}</div>
								<div class="line"></div>
							</div>
						</div>
						<div class="navImg" v-if="listThree && listThree.length > 0">
							<div class="navImgItem" v-for="(item, index) in listThree">
								<img :src="webImg + item.picture + imgCut(180,175)" alt="" @dragstart.prevent>
								<div class="navMainTitle">{{ item.title }}</div>
							</div>

						</div>
					</div>
				</div>

				<!-- <div class="name" v-if="info.moduleThree">{{ info.moduleThree }}</div>
				<div v-if="listThree && listThree.length > 0"
					style="display: flex;flex-wrap: wrap;width: 1210px;margin: 0 auto;">
					<div class="listText" v-for="(item, index) in listThree">
						<img :src="webImg + item.picture" alt=""
							style="width: 370px;height: 404px;border-radius: 5px;object-fit: cover" @dragstart.prevent>
						<div class="nameNavMainTitle">{{ item.title }}</div>
					</div>

				</div>
				<div class="division "></div> -->
			</div>
		</div>
		<div class="device-pc" v-else>
			<div class="vocational">
				<div class="top" style="width: 100vw;height:25.17vw;">
					<el-carousel trigger="click" height='25.17vw'>
						<el-carousel-item v-for="(item, index) in topList" :key="index">
							<img :src="webImg + item +imgCut(1920,251,'r')" alt="" srcset="" style="width: 100vw;!important; height:25.17vw;"
								@dragstart.prevent>
						</el-carousel-item>
					</el-carousel>

				</div>

				<!-- <div class="navigation">
			        <img src="../assets/home.png" alt=""> <span @click="toTopImg()">{{ $t('nav.home') }}</span> ＞ {{ $t('nav.businessArea') }} ＞ {{ info.title }}
			    </div> -->
				<div class="navigation">
					<div class="navigationItem">
						<img src="../assets/home.png" alt=""> <span @click="toTopImg()" style="cursor: pointer;"
							@dragstart.prevent>{{ $t('nav.home') }}</span>
						<span style="color: black;">></span><span>{{ sectionTitle }}</span><span style="color: black;">></span><span>{{
							info.title
						}}</span>
					</div>
				</div>
				<div class="name">{{ info.title }}</div>
				<div class="line">
					<div class="lineItem"></div>
				</div>
				<div class="net" v-if="checkURL(info.link)"><a :href="info.link">{{ info.link }}</a></div>
				<div class="net" v-if="!checkURL(info.link)"><a :href="'http://www.' + info.link">{{ info.link }}</a>
				</div>
				<div class="introduce" v-if="info.content" v-html="formatRichText(info.content)"></div>
				<div class="jx" v-for="(item, index) in info.label" v-if="info.label && info.label.length > 0">
					<div style="display: flex;align-items: center;"> <img src="../assets/jx.png" alt=""
							@dragstart.prevent>{{
								item.label }}</div>
					<div v-for="(item1, index) in item.children" style="margin-left: 30px;margin-top: 10px;">
						<div style="display: flex;align-items: center;"> {{ item1.label }}</div>
					</div>
				</div>
				<div class="division "></div>
				<div class="name" v-if="info.moduleOne">{{ info.moduleOne }}</div>

				<div class="nav" v-if="list && list.length > 0">
					<div style="position: relative;">

						<i class="el-icon-arrow-left" @click="toLeft()"
							style="font-size: 24px;cursor: pointer;position: absolute;left: -30px;top: 30px;"
							v-if="moduleOneTotal > 5 && pageNum >= 1"></i>
						<div class="navMain" style="background-color: aqua;">
							<div @click="navMainClick(index)" v-for="(item, index) in list" class="navMainItem"
								:class="{ navMainItem1: count == index }">
								<div v-html="item.name"></div>

							</div>
						</div>
						<i class="el-icon-arrow-right" @click="toRight()"
							style="font-size: 24px;cursor: pointer;position: absolute;right: -30px;top: 30px;"
							v-if="moduleOneTotal > 5 && pageNum < moduleOneTotalNum"></i>
					</div>

				</div>
				<div class="navImg" v-if="listOne && listOne.length > 0">
					<div class="navImgItem" v-for="(item, index) in listOne">
						<img :src="webImg + item.picture + imgCut(385,470)" alt="" @dragstart.prevent>
						<div class="navMainTitle">{{ item.title }}</div>
					</div>
				</div>
				<!-- <div class="division "></div> -->
				<div class="name" style="position: relative;" v-if="info.moduleTwo">{{ info.moduleTwo }}
					<div style="width: 1210px;margin: 0 auto;position: absolute;top: 260%;z-index: 999;">
						<div style="width: 395px;">
							<div class="angin" v-if="listTwo[num - 1]">{{ listTwo[num - 1].title }}</div>
							<div class="anginText" v-if="listTwo[num - 1]" v-html="listTwo[num - 1].content">
							</div>
						</div>

					</div>
				</div>

				<div class="technology" v-if="listTwo && listTwo.length > 0"  :style="{width:(screenWidth + 'px')}">
			
					<div class="technologyName" :style="{width:screenWidth/2 + 'px'}">
						<div class="anginImg" >
							<div>{{ num }}/<span>{{ totalNum }}</span> </div>
							<div class="aLeft" @click="aLeftClick()"> <i class="el-icon-arrow-left"></i></div>
							<div class="aRight" @click="aRight()"> <i class="el-icon-arrow-right"></i></div>
						</div>
					</div>

					<img :style="{width:(screenWidth - (screenWidth/2)) + 'px'}" class="technologyImg" v-if="listTwo[num - 1]" :src="webImg + listTwo[num - 1].picture + imgCut((screenWidth - (screenWidth/2)),460)" alt=""
						@dragstart.prevent>


				</div>
				<!-- <div class="division "></div> -->
				<div class="name" v-if="info.moduleThree">{{ info.moduleThree }}</div>
				<div v-if="listThree && listThree.length > 0"
					style="display: flex;flex-wrap: wrap;width: 1210px;margin: 0 auto;">
					<div class="listText" v-for="(item, index) in listThree">
						<img :src="webImg + item.picture + imgCut(370,404)" alt=""
							style="width: 370px;height: 404px;border-radius: 5px;object-fit: cover" @dragstart.prevent>
						<div class="nameNavMainTitle">{{ item.title }}</div>
					</div>

				</div>
				<div class="division "></div>
			</div>
		</div>
	</div>
</template>

<script>

import {
	businessDetail,
	businessOneList,
	businessOne,
	businessTwo,
	businessThree,
	menuAll
} from '../api/api'
import { attachNavMeta, findNavByType } from '../utils/cmsNav'
export default {
	data() {
		return {
			list: [], //二级菜单数组
			id: this.$route.query.id || '', //二级菜单数组id
			parentId: this.$route.query.parentId || '',
			sectionTitle: '',
			count: 0,
			pageNum: 1,
			pageSize: 5,
			info: {},
			listOne: [],
			listTwo: [],
			listThree: [],
			num: 1,
			totalNum: 1,
			topList: [],
			moduleOneTotalNum: 1,
			moduleOneTotal: 1,
			screenWidth:''

		};
	},
	created() {
		this.screenWidth = window.innerWidth ;
		console.log(this.screenWidth,'this.screenWidth');
		this.count = 0
		this.loadSectionTitle()
		this.getBusinessDetail() //二级菜单
		this.$bus.$on('localeChanged', this.reloadData)
	},
	beforeDestroy() {
		this.$bus.$off('localeChanged', this.reloadData)
	},
	watch: {
		$route(to, from) {
			this.count = 0
			this.id = to.query.id
			this.parentId = to.query.parentId || ''
			this.loadSectionTitle()
			this.getBusinessDetail() //二级菜单
		},
	},
	mounted() {

	},
	methods: {
		reloadData() {
			this.loadSectionTitle()
			this.getBusinessDetail()
		},
		loadSectionTitle() {
			this.parentId = this.$route.query.parentId || ''
			menuAll(true).then((navRes) => {
				const navList = (navRes.data || []).map(attachNavMeta)
				const section = this.parentId
					? navList.find((item) => String(item.menuId) === String(this.parentId))
					: findNavByType(navList, 'business')
				this.sectionTitle = section ? section.menuName : ''
			})
		},
		//二级菜单
		getBusinessDetail() {
			console.log('mihahah');
			businessDetail(this.id).then(res => {
				this.topList = res.data.picture.split(',')
				console.log(this.topList, ' this.topList');
				res.data.label = JSON.parse(res.data.label)
				this.info = res.data
				this.getBusinessOneList(res.data.id)
				this.getBusinessTwo(res.data.id)
				this.getBusinessThree(res.data.id)

			})
		},
		handleClick(tab, event) {
			console.log(tab, event);
		},
		//模块一列表
		getBusinessOneList(id) {
			if (id == 13) {
				this.pageSize = 3
			}
			businessOneList(this.pageNum, this.pageSize, id).then(res => {
				this.list = res.data
				this.moduleOneTotal = res.total
				this.moduleOneTotalNum = Math.ceil(res.total / 5)

				//模块一详情
				this.getBusinessOne(res.data[0].id)
			})
		},
		//模块一详情
		getBusinessOne(id) {
			businessOne(id).then(res => {
				this.listOne = res.data
			})
		},
		//模块一详情点击
		navMainClick(index) {
			this.count = index
			this.getBusinessOne(this.list[index].id)
		},
		//模块二
		getBusinessTwo(id) {
			businessTwo(id).then(res => {
				this.listTwo = res.data
				this.totalNum = res.data.length
			})
		},
		//模块三
		getBusinessThree(id) {
			businessThree(id).then(res => {
				this.listThree = res.data
				console.log(this.listThree, ' this.listThree');
			})
		},
		aLeftClick() {
			if (this.num <= 1) {
				return this.num = this.totalNum
			}
			this.num--
		},
		aRight() {
			if (this.num >= this.totalNum) {
				return this.num = 1
			}
			this.num++
		},
		toLeft() {
			this.count = 0
			if (this.pageNum <= 1) {
				return
			} else {
				this.pageNum--
				this.getBusinessOneList(this.id)
			}

		},
		toRight() {
			this.count = 0
			if (this.pageNum >= this.moduleOneTotalNum) {
				this.pageNum = 1
				this.getBusinessOneList(this.id)
			} else {
				this.pageNum++
				this.getBusinessOneList(this.id)
			}

		},
		//首页
		toTopImg() {
			this.$router.push({
				path: '/home',
				query: {
					index: 0
				}
			})
		},
	}
};
</script>

<style scoped lang="scss">
.device-mobile {
	background: #F5F5F5;

	.vocational {
		width: 100vw;

		.card {
			width: 100%;
			margin-bottom: 0.133333rem;
			background: #FFFFFF;
			padding-bottom: 0.533333rem;

			.card-content {
				width: 9.466667rem;
				margin: 0 auto;

				.navigation {
					width: 100%;

					// background: #F5F5F5;
					// padding: 0 0.333333rem;
					.navigationItem {
						display: flex;
						align-items: center;
						padding-top: 0.36rem;
						// height: 1.066667rem;
						color: #1979b7;
						font-size: 0.333333rem;

						.arrow {
							color: #030303;
							margin: 0 0.133333rem;
						}

						img {
							width: 0.333333rem;
							height: 0.333333rem;
							margin-right: 0.133333rem;
						}
					}
				}

				.tabbar {
					width: 100%;
					height: 1.653333rem;
					display: flex;
					align-items: center;

					.item {
						position: relative;
						display: flex;
						flex-direction: column;
						margin-right: 0.4rem;

						&.active {
							.txt {
								font-size: 0.453333rem;
								font-weight: bold;
								color: #000000;
							}

							.line {
								display: block;
							}
						}

						.txt {
							font-size: 0.4rem;
							font-weight: 400;
							color: #000000;
						}

						.line {
							position: absolute;
							bottom: -0.266667rem;
							display: none;
							margin-top: 0.213333rem;
							width: 1.2rem;
							height: 0.053333rem;
							background: #007CC3;
							border-radius: 0px 0px 0px 0px;
							opacity: 1;
						}
					}
				}

				.net {
					width: 1210px;
					margin: 0 auto;
					font-size: 21px;
					font-weight: 400;
					color: #000000;
					margin-top: 28px;

					a {
						text-decoration: none;
						color: #000000;
					}

					a:hover {
						text-decoration: underline;
						color: #0076BE;
					}
				}

				.introduce {
					font-size: 0.346667rem;
					font-weight: 400;
					color: #545454;
					margin: 0.4rem 0;
				}

				.jx {
					margin-top: 12px;

					.img-box {
						display: flex;
						align-items: center;
						height: 0.533333rem;

						img {
							width: 0.32rem;
							height: 0.32rem;
							margin-right: 0.266667rem;
						}
					}

					.txt {
						font-size: 0.346667rem;
						font-weight: bold;
						color: #000000;
						line-height: 0.533333rem;
					}
				}

				.nav {
					width: 100%;
					display: flex;
					margin: 0 auto;
					justify-content: center;
					align-items: center;

					img {
						width: 21px;
						height: 25px;
						cursor: pointer;
					}

					.navMain {
						width: 100%;
						display: flex;
						flex-wrap: wrap;


						.navMainItem {
							// width: 204px;
							min-width: 1.76rem;
							height: 0.853333rem;
							background: #0175C2;
							border-radius: 0px 0px 0px 0px;
							opacity: 1;
							margin-right: 0.133333rem;
							margin-bottom: 0.266667rem;
							box-sizing: border-box;
							padding: 0.133333rem;

							font-size: 0.373333rem;
							font-weight: 400;
							color: #FFFFFF;
						}

						.navMainItem1 {
							background: #0175C2;
						}
					}
				}

				.navImg {
					width: 100%;
					display: flex;
					flex-wrap: wrap;
					justify-content: space-between;

					.navImgItem {
						width: 4.6rem;
						height: 4.506667rem;
						position: relative;
						margin-top: 0.333333rem;
						border-radius: 0.266667rem;
						overflow: hidden;

						.navMainTitle {
							position: absolute;
							bottom: 0;
							width: 100%;
							height: 0.773333rem;
							box-sizing: border-box;
							padding: 0 0.133333rem;
							background: rgba(0, 0, 0, 0.4);
							display: flex;
							justify-content: center;
							align-items: center;
							font-size: 0.32rem;
							font-weight: 400;
							color: #FFFFFF;
							text-align: center;
						}

						img {
							object-fit: cover;
							width: 100%;
							height: 100%;

						}
					}

					.navImgItem:nth-child(3n) {
						margin-right: 0;
					}
				}

				.technology {
					width: 100%;
					display: flex;
					flex-direction: column;
					position: relative;


					.technologyName {
						width: 100%;
						background: #3A3939;
						box-sizing: border-box;
						position: relative;

						.angin {
							font-size: 0.4rem;
							font-weight: bold;
							color: #FFFFFF;
							margin-bottom: 0.266667rem;
						}

						.anginText {
							font-size: 0.32rem;
							font-weight: 400;
							color: #828282;
						}

						.anginImg {
							// position: absolute;
							float: right;
							display: flex;
							align-items: center;
							font-size: 0.32rem;
							font-weight: 400;
							color: #FFFFFF;

							span {
								font-size: 0.2rem;
							}

							.el-icon-arrow-left {
								color: #2A2A2A;
							}

							.el-icon-arrow-right {
								color: #2A2A2A;
							}

							.aLeft {
								width: 0.733333rem;
								height: 0.733333rem;
								background: #FFFFFF;
								margin-left: 0.266667rem;
								display: flex;
								justify-content: center;
								align-items: center;
								cursor: pointer;
							}

							.aRight {
								width: 0.733333rem;
								height: 0.733333rem;
								background: #FFFFFF;
								display: flex;
								justify-content: center;
								align-items: center;
								cursor: pointer;
							}
						}
					}

					.technologyImg {
						width: 100%;
						box-shadow: 0 0 16px 5px #e0dedf;

						img {
							width: 100%;
							height: 100%;
							box-shadow: 0 0 16px 5px #e0dedf;
						}
					}
				}

				.contact {
					display: flex;
					flex-wrap: wrap;
					justify-content: space-between;

					.listText {
						margin-right: 30px;
						margin-top: 20px;
						width: 370px;
						height: 404px;
						position: relative;
						border-radius: 10px;
						overflow: hidden;

						img {
							transition: transform 2s cubic-bezier(.23, 1, .32, 1);
						}
					}

					.nameNavMainTitle {
						position: absolute;
						left: 0;
						bottom: 0;
						width: 100%;
						height: 58px;
						background: rgba(0, 0, 0, 0.4);
						display: flex;
						justify-content: center;
						align-items: center;
						font-size: 21px;
						font-weight: 400;
						color: #FFFFFF;
						border-radius: 0 0 10px 10px;
					}
				}
			}
		}
	}

	.el-carousel__container {
		height: 25.17vw !important;
		//   width: 100vw;
	}
}

.device-pc {
	.vocational {
		background: #FFFFFF;
		padding-bottom: 20px;
		width: 100vw;
	}

	.top {
		height: 427px;
		width: 100vw;

		.topText {
			font-size: 65px;
			font-weight: 500;
			color: #FFFFFF;
			margin-top: -230px;
			margin-left: 105px;
		}

		// div {
		//     font-size: 65px;
		//     font-weight: 500;
		//     color: #FFFFFF;
		//     margin-top: -230px;
		//     margin-left: 105px;
		// }

		img {
			height: 427px;
			width: 100vw;

		}

	}

	.navigation {
		width: 1210px;
		margin: 0 auto;
		font-size: 16px;
		font-weight: 400;
		color: #545454;
		display: flex;
		align-items: center;
		cursor: pointer;
		// margin-top: 15px;

		img {
			width: 20px;
			height: 20px;
			margin-right: 7px;

		}
	}

	.name {
		width: 1210px;
		margin: 0 auto;
		font-size: 32px;
		font-weight: 600;
		color: #000000;
		margin-top: 60px;

		.angin {
			font-size: 29px;
			font-weight: 500;
			color: #FFFFFF;
			// width: 17vw;
		}

		.anginText {
			font-size: 16px;
			font-weight: 400;
			color: #FFFFFF;
			margin-top: 28px;
			line-height: 33px;
			// width: 17vw;
		}
	}

	.line {
		width: 1210px;
		margin: 0 auto;
		margin-top: 40px;

		.lineItem {
			width: 63px;
			height: 5px;
			background: #0175C2;
		}

	}

	.net {
		width: 1210px;
		margin: 0 auto;
		font-size: 21px;
		font-weight: 400;
		color: #000000;
		margin-top: 28px;

		a {
			text-decoration: none;
			color: #000000;
		}

		a:hover {
			text-decoration: underline;
			color: #0076BE;
		}
	}

	.introduce {
		width: 1210px;
		margin: 0 auto;
		font-size: 16px;
		font-weight: 400;
		// color: #545454;
		margin-top: 32px;
		margin-bottom: 12px;
	}

	.jx {
		width: 1210px;
		margin: 0 auto;
		// display: flex;
		// align-items: center;
		margin-top: 12px;

		img {
			width: 17px;
			height: 17px;
			margin-right: 10px;
		}

		font-size: 14px;
		font-weight: 600;
		color: #000000;
	}

	.division {
		width: 100vw;
		height: 10px;
		background: #F2F2F2;
		margin-top: 50px;
	}

	.nav {
		display: flex;
		margin: 0 auto;
		justify-content: center;
		margin-top: 35px;
		// margin-right: 40px;
		// position: relative;
		align-items: center;

		img {
			width: 21px;
			height: 25px;
			cursor: pointer;
		}

		.navMain {
			width: 1210px;
			height: 80px;
			// margin-left: 25px;
			// margin-right: 25px;
			display: flex;
			justify-content: space-between;
			cursor: pointer;


			.navMainItem {
				// width: 204px;
				flex: 1;
				height: 80px;
				background: #504E4E;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 21px;
				font-weight: 400;
				color: #FFFFFF;
				border-right: 1px solid #fff;
				white-space: pre-wrap;

				div {
					width: 90%;
					display: flex;
					align-items: center;
					justify-content: center;
					text-align: center;
				}
			}

			.navMainItem1 {
				background: #0175C2;
			}
		}
	}

	.navImg {
		width: 1210px;
		margin: 0 auto;
		display: flex;
		flex-wrap: wrap;
		// justify-content: space-between;


		.navImgItem {
			width: 385px;
			// width: 440px;
			height: 470px;
			position: relative;
			margin-top: 25px;
			margin-right: 25px;
			overflow: hidden;
			border-radius: 10px;
			box-shadow: 0 0 16px 5px #e0dedf;

			.navMainTitle {
				position: absolute;
				bottom: 0;
				width: 100%;
				height: 58px;
				background: rgba(0, 0, 0, 0.4);
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 21px;
				font-weight: 400;
				color: #FFFFFF;
				text-align: center;
				overflow: hidden;
				border-radius: 0 0 10px 10px;
			}

			img {
				object-fit: cover;
				width: 100%;
				height: 100%;
				transition: transform 2s cubic-bezier(.23, 1, .32, 1);
				border-radius: 10px;
				box-shadow: 0 0 16px 5px #e0dedf;

			}
		}

		.navImgItem:nth-child(3n) {
			margin-right: 0;
		}


		.navImgItem:hover {
			img {
				transition: transform 2s cubic-bezier(.23, 1, .32, 1);
				transform: scale(1.1);
			}

		}

	}

	.technology {
		// width: 100vw;
		margin: auto;
		height: 460px;
		display: flex;
		margin-top: 20px;
		position: relative;


		.technologyName {
			// width: 40vw;
			background: #3A3939;
			// display: flex;
			// flex-direction: column;
			// // justify-content: center;
			// align-items: center;
			padding: 53px 43px 0 108px;
			box-sizing: border-box;
			position: relative;
			//     box-shadow: 0 0 16px 5px #e0dedf;


		}

		.technologyImg {
			// width: 60vw;
			// width: 839px;
			height: 100%;
			box-shadow: 0 0 16px 5px #e0dedf;

			img {
				// width: 100%;
				height: 100%;
				box-shadow: 0 0 16px 5px #e0dedf;
			}
		}

		.anginImg {
			position: absolute;
			right: 0;
			bottom: 0px;
			display: flex;
			align-items: center;
			font-size: 24px;
			font-weight: 400;
			color: #FFFFFF;

			span {
				font-size: 15px;
			}

			.el-icon-arrow-left {
				color: #2A2A2A;
			}

			.el-icon-arrow-right {
				color: #2A2A2A;
			}

			.aLeft {
				width: 55px;
				height: 55px;
				background: #FFFFFF;
				margin-left: 35px;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
			}

			.aRight {
				width: 55px;
				height: 55px;
				background: #FFFFFF;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
			}

			.aLeft:hover,
			.aRight:hover {
				background: #0175C2;
			}
		}

		.angin {
			font-size: 29px;
			font-weight: 500;
			color: #FFFFFF;
			width: 405px;
		}

		.anginText {
			font-size: 16px;
			font-weight: 400;
			color: #FFFFFF;
			margin-top: 28px;
			line-height: 33px;
			width: 405px;

		}
	}

	.listText {
		margin-right: 30px;
		margin-top: 20px;
		width: 370px;
		height: 404px;
		position: relative;
		border-radius: 10px;
		overflow: hidden;

		img {
			transition: transform 2s cubic-bezier(.23, 1, .32, 1);
		}
	}

	.listText:hover {

		// transform: scaleX(20%);
		img {
			transition: transform 2s cubic-bezier(.23, 1, .32, 1);
			transform: scale(1.1);
		}
	}

	.nameNavMainTitle {
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 58px;
		background: rgba(0, 0, 0, 0.4);
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 21px;
		font-weight: 400;
		color: #FFFFFF;
		border-radius: 0 0 10px 10px;
	}

	.navigation {

		width: 100vw;
		background: #f5f5f5;
		display: flex;
		align-items: center;

		.navigationItem {
			width: 1200px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			// margin-top: 15px;
			height: 36px;
			line-height: 36px;
			margin-bottom: 20px;
			padding-top: 15px;
			box-sizing: border-box;
			color: #1979b7;
			font-size: 20px;
		}

		img {
			width: 20px;
			height: 20px;
			margin-right: 7px;

		}
	}

	.el-carousel__container {
		height: 25.17vw !important;
		//   width: 100vw;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/vocational.vue